module.exports = __webpack_public_path__ + "media/images/front/sp/institution-treatment-information/img_doctor02-45b3f1225cd980007d2b5b11d774dac1.jpg";